import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../auth/state/auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(route, state);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.store.select(selectAuthState).pipe(
      filter((auth) => !auth.isLoading),
      map((authState) => {
        return authState.user;
      }),
      map((user) => {
        const isAuth = !!user;
        if (isAuth) {
          return true;
        }

        // If the URL already carries an outer "p", reuse it to avoid nesting
        const existingPath = route.queryParamMap.get('p');
        const intended = existingPath ?? state.url;

        return this.router.createUrlTree(['/auth'], {
          queryParams: { p: intended }, // Angular will URL-encode this value
        });
      }),
    );
  }
}
